import { validateRules } from '@fp/core/scoring/rules';
import type { ScoringRules } from '../lib/types';
import { Field } from './ui';

const NUMS: [keyof ScoringRules, string, string][] = [
  ['exactScore', 'Exact score', 'Predicted 2-1, finished 2-1'],
  ['goalDifference', 'Goal difference', '2-1 vs 3-2. 0 turns this tier off'],
  ['correctOutcome', 'Result only', 'Right winner or draw'],
  ['halfTimeOutcome', 'Half-time bonus', 'Right half-time leader'],
  ['firstScorer', 'First scorer bonus', 'Own goals never count'],
];

/** Points table editor with the same checks the server applies. */
export function RulesEditor({ value, onChange }: { value: ScoringRules; onChange: (r: ScoringRules) => void }) {
  const errors = validateRules(value);
  return (
    <div className="stack">
      <div className="form-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))' }}>
        {NUMS.map(([k, label, hint]) => (
          <Field key={k} label={label} hint={hint}>
            <input
              className="input"
              type="number"
              min={0}
              max={1000}
              value={value[k] as number}
              onChange={(e) => onChange({ ...value, [k]: e.target.value === '' ? 0 : Math.trunc(Number(e.target.value)) })}
            />
          </Field>
        ))}
        <Field label="Knockout result" hint="Which score counts when a cup tie goes to extra time">
          <select className="select" value={value.resultBasis} onChange={(e) => onChange({ ...value, resultBasis: e.target.value as ScoringRules['resultBasis'] })}>
            <option value="AFTER_EXTRA_TIME">After extra time (120 min)</option>
            <option value="REGULAR_TIME">After 90 minutes</option>
          </select>
        </Field>
      </div>
      <span className="muted small">
        Best case per match: {value.exactScore + value.halfTimeOutcome + value.firstScorer} points. Result tiers don't add up: only the best one applies.
      </span>
      {errors.length > 0 && (
        <div className="err-box">
          {errors.map((e) => (
            <div key={e}>{e}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export const rulesValid = (r: ScoringRules) => validateRules(r).length === 0;
